import { useBoolean } from "@/hooks/use-boolean";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { t } from "i18next";
import { PropsWithChildren, useCallback } from "react";
import { CarrierTransportForm } from "./carrier-transport-form";
import { useCarriersContext } from "../../use-carriers-context";
import {
  CreateCarrierDto,
  UpdateCarrierDto,
  UpsCarrierPreferenceDto,
} from "@babackapp/private-api-client/types";

export const AddCarrierTransportDialog = ({ children }: PropsWithChildren) => {
  const open = useBoolean(false);
  const { addOneCarrierTransport, addOneUpsCarrierTransport } =
    useCarriersContext();
  const onSubmitAddCarrierTransport = useCallback((data: CreateCarrierDto) => {
    if (data.code.includes("ups")) {
      addOneUpsCarrierTransport({
        carrierType: data.code,
        accountNumber:
          ((data.credentials as UpsCarrierPreferenceDto)
            .accountNumber as string) || "",
      });
      return;
    }

    addOneCarrierTransport(data);
    open.setValue(false);
  }, []);

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle> {t("carrier.label")}</DialogTitle>
          <DialogDescription>{t("carrier.subLabel")}</DialogDescription>
        </DialogHeader>
        <CarrierTransportForm
          onSubmitUps={addOneUpsCarrierTransport}
          onSubmit={
            onSubmitAddCarrierTransport as (
              data: CreateCarrierDto | UpdateCarrierDto,
            ) => void
          }
        />
      </DialogContent>
    </Dialog>
  );
};
